import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'

import { CUSTOM_POSITIONS, POSITION_OPTION, SELECT_ALL_POSITIONS } from '../../fields'

import PositionFields from '../../../../../reusableFormFields/PositionFields'

const PositionStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  return (
    <Step stepTitle="Please select position on screen and position in content" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={POSITION_OPTION + SELECT_ALL_POSITIONS}
        name={POSITION_OPTION}
        value={SELECT_ALL_POSITIONS}
        selectedValue={values[POSITION_OPTION]}
        label={t('Select All')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={POSITION_OPTION + CUSTOM_POSITIONS}
        name={POSITION_OPTION}
        value={CUSTOM_POSITIONS}
        selectedValue={values[POSITION_OPTION]}
        label={t('Custom')}
      >
        <PositionFields formik={formik} />
      </RadioBlock>
    </Step>
  )
}

export default PositionStep
